export const publisherConstants = {
    GET_REQUEST: 'PUBLISHER_GET_REQUEST',
    GET_SUCCESS: 'PUBLISHER_GET_SUCCESS',
    GET_FAILURE: 'PUBLISHER_GET_FAILURE',
    GET_FAILURE_DONE: 'PUBLISHER_GET_FAILURE_DONE',

    // Kept distinct from GET_* above so fetching the pinned list never
    // clears/reloads the all-publishers list (or vice versa) - same
    // separation as newspinConstants.NEWSPIN_SAVE_* keeping savedNewsList
    // independent of the rest of the newspin slice.
    GET_MY_REQUEST: 'PUBLISHER_GET_MY_REQUEST',
    GET_MY_SUCCESS: 'PUBLISHER_GET_MY_SUCCESS',
    GET_MY_FAILURE: 'PUBLISHER_GET_MY_FAILURE'
}